import type { Slug } from "@spare-cart/contracts/common";
import { usePublicSettings } from "./usePublicSettings";

export type VehicleTypesState = {
  enabledTypes: readonly Slug[];
  defaultType: Slug | undefined;
  showSelector: boolean;
  isLoading: boolean;
};

export const useVehicleTypes = (): VehicleTypesState => {
  const { data, isPending } = usePublicSettings();
  const enabledTypes = data?.enabledVehicleTypes ?? [];

  return {
    enabledTypes,
    defaultType: enabledTypes[0],
    showSelector: data?.showVehicleTypeSelector ?? false,
    isLoading: isPending,
  };
};
